var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showFilter":true,"showSearch":true,"showExportation":true},on:{"addEvent":function($event){return _vm.$router.push({name: ''})}}},[_vm._v(_vm._s(_vm.$t('trips.withdrawProcess')))]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":'vehicles',"additional-url":"filters[companyId]=1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }